module.exports = __webpack_public_path__ + "img/swiper_3.0_4_2.8364efd8.webp";